<template>
  <form-row
    :label="label"
    :error-message="errorMessage"
  >
    <div class="form-radios">
      <label
        v-for="(label, value) in inputValues"
        :key="label"
      >
        <input
          v-model="checked"
          type="radio"
          :name="name"
          :value="value"
          :disabled="disabled"
        > {{ label }}
      </label>
    </div>
  </form-row>
</template>

<script lang="ts">
import {Component, Vue, Prop} from "vue-property-decorator";
import formRow from "./form-row.vue";

@Component({
  components: {
    formRow
  }
})
export default class Radios extends Vue {
  @Prop() readonly label!: string;
  @Prop() readonly name!: string;
  @Prop() readonly value!: string;
  @Prop() readonly errorMessage!: string;
  @Prop({default: () => { return {}; }}) readonly inputValues!: Record<string,string>;
  @Prop({default: false}) disabled!: boolean;

  get checked(): string {
    return this.value;
  }

  set checked(v: string) {
    this.$emit('input', v);
  }

  input(e: Event): void {
    const target = e.target as HTMLInputElement;
    this.$emit('input', target.value);
  }
}
</script>

<style scoped>
.form-radios {
  label {
    margin: .5em 1.5em .5em 0;
    display: inline-flex;
    align-items: center;
  }

  input {
    margin-right: .5em;
  }
}
</style>
